import {
    ModelSetTransformer,
    ModelTransformer,
} from '../../common/common.model';

import { ModelBase } from './tag.coaching.model';

export interface BehaviourItem {
    id: number;
    initials: string;
    shortName: string;
    name: string;
}

class BehaviourModelTransformer
    implements ModelTransformer<BehaviourItem, ModelBase>
{
    transform(model: ModelBase): BehaviourItem {
        return {
            id: model.id,
            initials: model.text.initials,
            shortName: model.text.shortName,
            name: model.text.name,
        };
    }
}

export class BehaviourModelSetTransformer extends ModelSetTransformer<
    BehaviourItem,
    ModelBase
> {
    protected newTransformer(): ModelTransformer<BehaviourItem, ModelBase> {
        return new BehaviourModelTransformer();
    }
}
